module.exports = "<main>\r\n  <h1>Congratulations on Creating Your Crim Account</h1>\r\n  <h3>Please visit <a routerLink=\"/\">here</a> to sign in.</h3>\r\n</main>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/confirmation/confirmation.component.html
// module id = ./src/app/confirmation/confirmation.component.html
// module chunks = app